import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SurveyTypes } from '../models/surveytypes';
import { CriteriaService } from '../services/criteria.service';
import { VisionService } from '../services/vision.service';
import { VisionModel } from './vision.model';
import { CriteriaDetails } from './dto/criteria';
import { User } from './dto/user';

@Injectable()
export class CriteriaModel {
    email: string;
    user_data: any;
    survey_data: any;
    criteriaData: any;

    constructor(private visionService: VisionService, private criteriaService: CriteriaService, private visionModel: VisionModel) {
        const user = JSON.parse(localStorage.getItem('user_data'));
        this.email = user.email;
    }

    criteriaIsExist(critTitle: string) {
        this.survey_data = JSON.parse(localStorage.getItem('user_data'));
        if (this.survey_data && this.survey_data !== 'null' && this.survey_data) {
            const surveyId = this.survey_data.id;
            return this.visionService.getVisionData(surveyId).map(result => {
                if (!result.Survey && result.Survey !== null) {
                    const critExist = result.Survey.criterias.filter(x => x.title === critTitle)[0];
                    if (critExist && critExist !== undefined) {
                        return true;
                    } else {
                        // no exist
                        return false;
                    }
                } else {
                    // no exist
                }
            });
        } else {
            // no exist
        }

    }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/models/criteria.model.ts